var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcDateInput(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.8,
    height: 14.774,
    viewBox: "0 0 13.8 14.774",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic-date-input",
    d: "M17.365,7.907H4.6a.5.5,0,0,0-.5.5V15.8a1.476,1.476,0,0,0,1.477,1.477H16.391A1.476,1.476,0,0,0,17.868,15.8V8.41A.5.5,0,0,0,17.365,7.907ZM8.532,14.791a.5.5,0,0,1-.5.5H7.055a.5.5,0,0,1-.5-.5v-.974a.5.5,0,0,1,.5-.5h.974a.5.5,0,0,1,.5.5Zm3.426,0a.5.5,0,0,1-.5.5h-.974a.5.5,0,0,1-.5-.5v-.974a.5.5,0,0,1,.5-.5h.974a.5.5,0,0,1,.5.5Zm0-3.426a.5.5,0,0,1-.5.5h-.974a.5.5,0,0,1-.5-.5V10.39a.5.5,0,0,1,.5-.5h.974a.5.5,0,0,1,.5.5Zm3.458,0a.5.5,0,0,1-.5.5h-.974a.5.5,0,0,1-.5-.5V10.39a.5.5,0,0,1,.5-.5h.974a.5.5,0,0,1,.5.5Zm.974-7.387H15.165v-.5a.974.974,0,1,0-1.949,0v.5H8.784v-.5a.974.974,0,1,0-1.949,0v.5H5.577A1.476,1.476,0,0,0,4.1,5.455v.5a.5.5,0,0,0,.5.5H17.4a.5.5,0,0,0,.5-.5v-.5A1.524,1.524,0,0,0,16.391,3.977Z",
    transform: "translate(-4.1 -2.5)",
    fill: "#8b9095"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDateInput);
export default __webpack_public_path__ + "static/media/ic-date-input.4c2a9cbf.svg";
export { ForwardRef as ReactComponent };